__turbopack_context__.v({
  "cityPage": "FaqSectionHome-module-scss-module__BbUVnG__cityPage",
  "container": "FaqSectionHome-module-scss-module__BbUVnG__container",
  "formSection": "FaqSectionHome-module-scss-module__BbUVnG__formSection",
  "layout": "FaqSectionHome-module-scss-module__BbUVnG__layout",
  "layoutSpecific": "FaqSectionHome-module-scss-module__BbUVnG__layoutSpecific",
  "lead-form-section": "FaqSectionHome-module-scss-module__BbUVnG__lead-form-section",
});
